import PropTypes from 'prop-types';

import PropTypesPresenter from '../../utils/PropTypesPresenter';
import DatePresenter from '../../presenters/DatePresenter';

const HEALTHY = 'healthy';

export default new PropTypesPresenter(
  {
    id: PropTypes.string,
    institutionName: PropTypes.string,
    institutionId: PropTypes.string,
    itemId: PropTypes.string,
    state: PropTypes.string,
    errorCode: PropTypes.string,
    accountOnboardedAt: PropTypes.string,
  },
  {
    plaidState(integrationItem) {
      if (this.state(integrationItem) === HEALTHY) {
        return 'Plaid account is in good state';
      }

      return `Plaid account is in error state. Error: ${this.errorCode(
        integrationItem
      )}`;
    },

    accountOnboardedAtReadable(integrationItem) {
      return DatePresenter.dateReadable(
        this.accountOnboardedAt(integrationItem)
      );
    },
  }
);
